import type { ComponentPublicInstance, Ref } from 'vue'

export type MaskedField = ComponentPublicInstance | null

/**
 * O `<input>` do VTextField é controlado pelo state (`value: model.value`), então ele só
 * reflete o que o state guarda. Quando a máscara devolve o mesmo valor de antes — dígito
 * digitado além do formato, caractere inválido — o state não muda, o Vue não re-renderiza
 * e o caractere a mais continuaria visível no campo. Daí a escrita direta no elemento.
 */
export function syncMaskedInput(field: Ref<MaskedField>, masked: string): void {
  const input = field.value?.$el?.querySelector('input') as HTMLInputElement | null
  if (input && input.value !== masked) {
    input.value = masked
  }
}
